import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layer-legend',
  templateUrl: './layer-legend.component.html',
  styleUrls: ['./layer-legend.component.scss']
})
export class LayerLegendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
